import { render, staticRenderFns } from "./ServicesCategories.vue?vue&type=template&id=1ed973f0&"
import script from "./ServicesCategories.vue?vue&type=script&lang=js&"
export * from "./ServicesCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports